module.exports = __webpack_public_path__ + "static/img/icon-welcome.6787deb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-welcome.png
// module id = TD5L
// module chunks = 0